import api from "./api";

const workvivoInboundKudosService = {
  getSuggestion: async (suggestionId) => {
    const response = await api.get(`/api/v1/workvivo/inbound-kudos/${suggestionId}`);
    return response.data;
  },
};

export default workvivoInboundKudosService;
